import Cookies from 'js-cookie'

export default async function getDocumentOnlyExistsOffline (docId) {
  return Cookies.get('onlyExistsOffline:kludd:' + docId) === 'true'
}
